import React, { useEffect, useState } from 'react';
import { Button, Text } from '@asigna/kit';
import { BATCH_TRANSFER_DISABLED } from 'components/Dialog/TransactionDialog/WidthdrawNftDialog/constants';
import { ImageWithPlaceholder } from 'components/ImageWithPlaceholder/ImageWithPlaceholder';
import useAddress from 'hooks/use-address';
import useSafe from 'hooks/use-safe';
import { NftSafeState } from 'types/NftTypes';
import { AddressBalance } from 'utils';
import { shortenAddress } from 'utils/helper';
import { getNftCollectionId } from 'utils/nft-tools';

import { useNftCollectionCardStyles } from './NftCollectionCardStyles';

type Props = {
  balance: Pick<AddressBalance, 'non_fungible_tokens'>;
  nftCollection: NftSafeState;
  /// TODO_R: rename to onNFTClick and call setSelectedNFTId outside
  setSelectedNFTCollectionId: React.Dispatch<React.SetStateAction<string>>;
  // TODO_R: create onNFTSendClick prop and call everything below from outside in a handler. Hence, remove 3 props below
  setSelectedCollectionId: React.Dispatch<React.SetStateAction<string>>;
  setSendNftDialogOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedNFTIds: React.Dispatch<React.SetStateAction<string[] | null>>;
};

// TODO_R: [FRS]
export const NftCollectionCard = ({
  balance,
  nftCollection,
  setSelectedNFTCollectionId,
  setSelectedCollectionId,
  setSelectedNFTIds,
  setSendNftDialogOpened,
}: Props) => {
  const { safe } = useSafe();
  const walletAccount = useAddress() || '';
  const [nftCountInCollection, setNftCountInCollection] = useState('');
  const classes = useNftCollectionCardStyles();

  useEffect(
    function calcNftCountInCollection() {
      const contract = Object.keys(balance.non_fungible_tokens).filter(
        (token) => getNftCollectionId(nftCollection.addr, nftCollection.title) === token
      );
      setNftCountInCollection(balance.non_fungible_tokens[contract[0]].count);
    },
    [nftCollection, balance.non_fungible_tokens]
  );

  const handleNFTSend = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setSelectedCollectionId(getNftCollectionId(nftCollection.addr, nftCollection.title));
    setSendNftDialogOpened(true);
    if (BATCH_TRANSFER_DISABLED) {
      return;
    }
    setSelectedNFTIds(nftCollection.images.map((image) => image.id));
  };

  return (
    <div
      className="flex flex-col items-center gap-16 rounded-[12px] bg-black-2 border border-black-4 p-24"
      onClick={() =>
        setSelectedNFTCollectionId(getNftCollectionId(nftCollection.addr, nftCollection.title))
      }
    >
      <div className={classes.nftsItemImages}>
        {nftCollection.images.slice(0, 4).map((image) =>
          image.isVideo ? (
            <video
              key={image.id}
              style={{
                objectFit: 'cover',
              }}
              className="w-72 h-72 perspective-62-rotate-y-17 ml-[-24px] rounded-[8px] border border-white-20 overflow-hidden shadow-[-8px_0px_12px_#1B1C2280]"
              src={image.image}
            ></video>
          ) : (
            <ImageWithPlaceholder
              key={image.id}
              className="w-72 h-72 perspective-62-rotate-y-17 ml-[-24px] rounded-[8px] border border-white-20 overflow-hidden shadow-[-8px_0px_12px_#1B1C2280]"
              src={image.image}
              alt={image.title}
            />
          )
        )}
        {nftCountInCollection && +nftCountInCollection > 4 && (
          <div>
            <Text message={`+${+nftCountInCollection - 4}`} size="m14" color="white" />
          </div>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <Text message={nftCollection.title} color="white" size="m16" />
        <Text message={shortenAddress(nftCollection.addr)} color="regular" size="r14" />
      </div>
      <Button
        disabled={!safe.owners.find((owner) => owner.address === walletAccount)}
        colorType="secondary"
        fullWidth
        onClick={handleNFTSend}
        message="Send NFT"
        size="sm"
      />
    </div>
  );
};
